import { makeStyles } from '@material-ui/core/styles';
import { convertPxToRem } from '../../../common/utils/helpers/GenericHelpers';

export const useStyles = makeStyles((theme) => ({
    container: {},
    item: {
        flex: 1,
        margin: '0 auto',
        display: 'flex',
        padding: convertPxToRem(10),
        flexDirection: 'column',
    },
}));
